import { MainHeader, Section, SectionParagraph } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import arrow from '@/static/assets/pet/scroll-arrow.png';
import { Flex, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import styled, { keyframes } from 'styled-components';

export const scrollArrowAnimation = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(20px);
    }
`;

export const TopSectionContainer = styled(Section)`
  position: relative;
  background-color: ${themedColor('white')};
  height: 800px;
  overflow: hidden;

  ${MEDIA_QUERIES.tabletAndDesktop`
        height: calc(100vh - 175px);
        overflow: visible;

    `}
`;

export const StyledTitle = styled(MainHeader)`
  margin: 0px 20px;
  text-transform: capitalize;
  ${MEDIA_QUERIES.tabletAndDesktop`
        white-space: pre;
        margin: 0px 30px;

    `}
`;

export const Subtitle = styled(SectionParagraph)`
  text-align: center;
  margin: 20px;
  ${font('main', {
    lineHeight: '2.8rem',
    fontSize: '1.6rem',
    fontWeight: 'normal',
  })};
  max-width: 400px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', {
          lineHeight: '2.8rem',
          fontSize: '2.0rem',
          fontWeight: 'normal',
        })};
        max-width: 600px;
    `}
`;

export const CTA = styled(JoinCTA)`
  margin: 15px 0px 19px;
  width: 233px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        margin-top: 40px;
        width: 258px;
    `}
`;

export const ContentContainer = styled(Flex)`
  position: relative;

  ${MEDIA_QUERIES.tabletAndDesktop`
        height: calc(100vh - 175px);
    `}
`;

export const ScrollArrowContainer = styled.div`
  width: 30px;
  margin-top: 15px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 30px;
        padding-bottom: 20px;
        margin-top: 0px;

    `}
`;

export const LogosWrapper = styled(Image)`
  margin: 30px 0px;
`;

export const ScrollArrow = styled.div`
  background-image: url(${arrow.src});
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  animation: ${scrollArrowAnimation} 1.5s ease-in-out alternate infinite;
`;

export const PetAnimationContainer = styled(Flex)`
  min-height: 400px;
  pointer-events: none;
  position: relative;
  width: 150%;
  margin-bottom: 20px;
  z-index: 1;
  bottom: 20px;

  ${font('alt', { fontSize: '2.0rem' })}
  ${MEDIA_QUERIES.tabletAndDesktop`
        height: 100vh;
        position: absolute;
        bottom: 85px;
    `};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    left: -25%;
    right: 0;
    width: 150%;
  }
`;

export const Guarantee = styled.p`
  ${font('main', { fontSize: '1.6rem' })};
`;

export const StyletGuaranteeIcon = styled(Image)`
  height: 12px;
  width: 18px;
`;

export const TrustpilotContainer = styled.div<{ showTrustpilot: boolean }>`
  opacity: ${({ showTrustpilot }) => (showTrustpilot ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  border: 1px solid ${themedColor('borderPrimary')};
  border-radius: 8px;
  height: 46px;
  padding: 13px 0px;
`;
